import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

const Testimonials = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div>
            <div className='container py-5 mb-5'>
                <div className=''>
                    <h1 className='text-center '><strong>What our students say</strong></h1>
                    <p className='bannerheading3'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy</p>
                </div>
                <Slider {...settings}>
                    {[
                        {
                            img: "img/avatar-4.png",
                            name: "Loren",
                            text: "I would like to take this opportunity to thank Abida who has been handling my case. She has been a real gem and has been very proactive, professional and helpful during this process. ",
                        },
                        {
                            img: "img/avatar-4.png",
                            name: "Bela",
                            text: "Thank you for your continued support. I confirm that I have received the funds into my Axis account. I wanted to appreciate and acknowledge the immense empathy .",
                        },
                        {
                            img: "img/avatar-4.png",
                            name: "John",
                            text: "Thanks a lot for your help and support. I could place the redemption request without any problem. We really appreciate the speed in which your team has solved this issue",
                        },
                        {
                            img: "img/avatar-4.png",
                            name: "Loren",
                            text: "I am writing to express my sincere gratitude for the invaluable support and guidance you have provided as my finance advisor. Thankyou for Your Support.",
                        }
                    ].map((testimonial, index) => (
                        <div key={index} className="slidee">
                            <div className="bg-white rounded p-4">
                                <div className=" ">
                                    <div className="bg-white rounded-circle ms-3" >
                                        <img src={testimonial.img} className="rounded-circle p-2" style={{ width: "80px", height: "80px", border: "1px solid var(--bs-primary)" }} alt={testimonial.name} />
                                    </div>
                                    <div className="my-3 mx-4">
                                        <h5>{testimonial.name}</h5>
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <div></div>
                                    <p className="mt-4 " style={{ textAlign: "justify" }}>{testimonial.text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}

export default Testimonials
